export default __webpack_public_path__ + "static/media/potilasohjeet.bdf107d9.svg";